import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "@/app/constants";
import { useAuthStore } from "@/stores/authStore";
import { pickHomeForRole } from "@/app/router/roleHome";

/**
 * Public-route guard. Redirects an already-signed-in user to *their own*
 * role-appropriate home so a client who lands on /login doesn't get
 * bounced into the admin shell (that was the old behavior — hard-coded
 * to `/dashboard`).
 */
export function GuestGuard() {
  const { user } = useAuthStore();

  if (user) {
    if (user.status === "Pending Approval") {
      return <Navigate to={ROUTES.pendingApproval} replace />;
    }
    return <Navigate to={pickHomeForRole(user.role)} replace />;
  }

  return <Outlet />;
}
